export default {
  headerContainer: {
    padding: '20px 20px 30px',
  },
  headerContainerV2: {
    padding: '0',
    // Sticky on the header (not the AppBar inside it, whose parent is only as
    // tall as itself). 1100 = MUI appBar: above content, below dialogs (1300).
    position: 'sticky',
    top: 0,
    zIndex: 1100,
  },
  headerSubHeaderText: {
    fontSize: '1.7rem',
  },
  headerLogo: {
    width: '100%',
    maxWidth: '450px',
  },
  headerEventContainer: {
    margin: '0 0 15px',
    padding: '20px 0',
    textAlign: 'center',
    '& h2': {
      fontSize: '1.3em',
    },
    '& a': {
      color: 'inherit',
    },
  },
  headerEventTitle: {
    '&:focus': { outline: 'none' },
  },
  headerEventSubTitleText: {
    marginTop: '10px',
  },
  headerEventDescriptionText: {
    marginTop: '30px',
  },
};
